import React, { useState } from 'react';
import { useTranslation } from '../redux/TranslationHelper';

function ImageComponent({ src, alt, style, content }) {
  const { t } = useTranslation();
  const [imgError, setImgError] = useState(false);
  
  // src와 alt를 직접 전달받거나 content 객체에서 추출
  const imageSrc = src || (content && content.src) || '';
  const imageAlt = alt || (content && content.alt) || '';
  
  // 이미지 에러 처리 함수
  const handleImageError = (e) => {
    console.error(t('이미지 로드 오류:'), imageSrc);
    setImgError(true);
    // 에러 발생 시 기본 플레이스홀더 이미지로 대체
    e.target.src = "https://via.placeholder.com/400x300?text=" + encodeURIComponent(t('이미지+로드+실패'));
  };
  
  // 에러 발생 시 기본 스타일 보존하며 에러 메시지 표시
  if (imgError) {
    return (
      <div style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: '#f0f0f0',
        border: '1px dashed #ccc',
        ...style
      }}>
        <img
          src={"https://via.placeholder.com/400x300?text=" + encodeURIComponent(t('이미지+로드+실패'))}
          alt={t("이미지 로드 실패")}
          style={{
            maxWidth: '100%',
            maxHeight: '100%'
          }}
        />
      </div>
    );
  }
  
  return (
    <img
      src={imageSrc}
      alt={imageAlt ? (typeof imageAlt === 'string' ? t(imageAlt) : imageAlt) : t('이미지')}
      onError={handleImageError}
      style={{
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        ...style
      }}
    />
  );
}

export default ImageComponent;